import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ProductList from './ProductList'
import { OrderFormContextProvider, ProductListContext } from '../../contexts'
import OrderForm from '../OrderForm'
import { Modal } from 'antd'

const ProductListContainer = () => {
  const {
    selectedProduct,
    productList,
    setFormModalVisible,
    formModalVisible,
  } = useContext(ProductListContext)

  const _onCloseForm = () => {
    setFormModalVisible(false)
  }

  const _renderOrderFormContext = ({ name }) => {
    const isSelectedProduct = name === selectedProduct

    return isSelectedProduct
      ? (
        <OrderFormContextProvider product={name} key={name}>
          <OrderForm product={name} />
        </OrderFormContextProvider>
      ) : null
  }

  return (
    <div className="product-list-container">
      <ProductList/>
      <Modal
        visible={formModalVisible}
        width={window.innerWidth - 100}
        centered={true}
        footer={null}
        onCancel={_onCloseForm}
      >
        { productList.map(_renderOrderFormContext)}
      </Modal>
    </div>
  )
}

ProductListContainer.propTypes = {
  selectedProduct: PropTypes.string,
  name: PropTypes.string
}

export default ProductListContainer
